import React, { useEffect } from "react";
import { AVAILABLE_UI_LANGUAGES, LANGUAGE_FLAGS } from "../constants/languages";
import { useT } from "../contexts/TranslationContext";

const LanguageModal = ({ isOpen, onClose, currentLanguage, onSelectLanguage }) => {
  const { t } = useT();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSelect = (lang) => {
    onSelectLanguage(lang);
    onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-[100]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-800 mb-4">{t("topBar.language")}</h2>
        <ul className="space-y-1">
          {AVAILABLE_UI_LANGUAGES.map((lang) => {
            const isSelected = lang === (currentLanguage || "English");
            return (
              <li key={lang}>
                <button
                  type="button"
                  onClick={() => handleSelect(lang)}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-left text-sm transition-colors ${
                    isSelected
                      ? "bg-blue-100 text-blue-800 font-medium"
                      : "text-gray-800 hover:bg-gray-100"
                  }`}
                >
                  <span className="text-2xl" aria-hidden>
                    {LANGUAGE_FLAGS[lang] ?? "🌐"}
                  </span>
                  <span>{lang}</span>
                  {isSelected && (
                    <span className="ml-auto text-blue-600" aria-hidden>
                      ✓
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
        <div className="mt-4 pt-3 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="w-full px-4 py-2 border border-gray-300 rounded bg-gray-50 text-gray-700 hover:bg-gray-100 text-sm font-medium"
          >
            {t("topBar.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
